import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function EmailIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25">
      <path d="M3.2 11.64v7.16h14.6v-7.16l-6.41 2.885c-.492.262-1.294.26-1.78 0L3.2 11.64zM2 18.997V9.002C2 8.455 2.451 8 3.007 8h14.985C18.552 8 19 8.45 19 9.002v9.995A1.01 1.01 0 0 1 17.992 20H3.007A1.004 1.004 0 0 1 2 18.997zM3.2 9.2v.801c0 .11.151.36.254.414l6.721 3.052c.135.072.513.072.65 0l6.72-3.052c.1-.052.255-.309.255-.414v-.8H3.2z" />
      <g transform="translate(5 5)">
        <path d="M1.2 1.2v.307A.502.502 0 0 1 .698 2H.502A.495.495 0 0 1 0 1.495V1c0-.552.455-1 1.002-1h14.995A1 1 0 0 1 17 .997v10.005A.997.997 0 0 1 16 12h-.495a.508.508 0 0 1-.505-.502v-.196c0-.277.22-.502.493-.502h.307V1.2H1.2z" />
      </g>
    </SvgIcon>
  )
}
